export default __webpack_public_path__ + "static/media/PIG_NOISE.c12f360f.wav";